import { clear, del, get, keys, set } from 'idb-keyval';

export default {
  getItem(key: string, callback?: (err: any, res: any) => void) {
    return get(key).then((val) => {
      callback?.(null, val);
      return val;
    });
  },
  setItem(key: string, value: string, callback?: () => void) {
    return set(key, value).then(() => {
      callback?.();
    });
  },
  removeItem(key: string, callback?: () => void) {
    return del(key).then(() => {
      callback?.();
    });
  },
  getAllKeys(callback?: (err: any, res: any) => void) {
    return keys().then((itemKeys) => {
      callback?.(null, itemKeys);
      return itemKeys;
    });
  },
  clear(callback?: () => {}) {
    return clear().then(() => {
      callback?.();
    });
  },
};
